import { useState } from "react";

interface TabItem {
    id: string;
    name: string;
    isActive?: boolean;
    content: React.ReactNode;
}

interface Props {
    tabItems: TabItem[];
}

const Tabs: React.FC<Props> = ({ tabItems }) => {
    const [activeTab, setActiveTab] = useState(tabItems[0].id);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    return (
        <div className="cmp-tabs py-3">
            {tabItems.length > 0 && (
                <ul className="nav nav-tabs mb-3" role="tablist">
                    {tabItems.map((item, index) => (
                        <li key={item.id} className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === item.id ? "active" : ""} ${
                                    index !== 0 ? "ms-3" : ""
                                }`}
                                id={item.id}
                                type="button"
                                role="tab"
                                aria-controls={item.id}
                                aria-selected={activeTab === item.id}
                                onClick={() => {
                                    handleTabClick(item.id);
                                }}
                            >
                                {item.name}
                            </button>
                        </li>
                    ))}
                </ul>
            )}

            {tabItems.length > 0 && (
                <div className="tab-content">
                    {tabItems.map((item) => (
                        <div
                            key={item.id}
                            className={`tab-pane fade ${
                                activeTab === item.id ? "show active" : ""
                            }`}
                            id={item.id}
                            role="tabpanel"
                            aria-labelledby={item.id}
                        >
                            <div className="row mx-0">
                                <div className="col-12">{item.content}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Tabs;
